import {gql, useMutation} from "@apollo/client";

const ADD_GAME_RESULT_MUTATION = gql`
mutation AddGameResult($profileId: Int!, $gameId: Int!, $scoreHome: Int!, $scoreVisitor: Int!, $eventStatus: String, $resetIndividualStats: Boolean, $observations: String, $forfeitTeamId: Int, $penaltiesHome: Int, $penaltiesVisitor: Int, $resultType: String, $homeShotsOnGoal: Int, $awayShotsOnGoal: Int, $homePenaltyMinutes: Int, $awayPenaltyMinutes: Int, $homeSaves: Int, $awaySaves: Int, $homePowerPlayGoals: Int, $awayPowerPlayGoals: Int, $homePowerPlayOpportunities: Int, $awayPowerPlayOpportunities: Int, $homeHits: Int, $awayHits: Int, $homeBlockedShots: Int, $awayBlockedShots: Int) {
  addGameResult(profileId: $profileId, gameId: $gameId, scoreHome: $scoreHome, scoreVisitor: $scoreVisitor, eventStatus: $eventStatus, resetIndividualStats: $resetIndividualStats, observations: $observations, forfeitTeamId: $forfeitTeamId, penaltiesHome: $penaltiesHome, penaltiesVisitor: $penaltiesVisitor, resultType: $resultType, homeShotsOnGoal: $homeShotsOnGoal, awayShotsOnGoal: $awayShotsOnGoal, homePenaltyMinutes: $homePenaltyMinutes, awayPenaltyMinutes: $awayPenaltyMinutes, homeSaves: $homeSaves, awaySaves: $awaySaves, homePowerPlayGoals: $homePowerPlayGoals, awayPowerPlayGoals: $awayPowerPlayGoals, homePowerPlayOpportunities: $homePowerPlayOpportunities, awayPowerPlayOpportunities: $awayPowerPlayOpportunities, homeHits: $homeHits, awayHits: $awayHits, homeBlockedShots: $homeBlockedShots, awayBlockedShots: $awayBlockedShots) {
    event{
        id
        title
        date
        status
        eventType
        season{
            name
            division{
                name
                organization{
                    name
                }
            }
        }
        field{
            id
            name
            sportFacility{
                latitude
                longitude
                address
            }
        }
        responsibles
        game{
            id
            homeTeam{
                id
                name
                logo
                players{
                        id
                        playerId
                        fullName
                        shirtNumber
                        status
                        position{
                            key
                            name
                        }
                    }
            }
            visitorTeam{
                id
                name
                logo
                players{
                        id
                        playerId
                        fullName
                        shirtNumber
                        status
                        position{
                            key
                            name
                        }
                    }
            }
            forfeitTeam{
                id
                name
                logo
            }
            scoreHome
            scoreVisitor
            penaltiesHome
            penaltiesVisitor
            resultType
            group{
                id
                name
            }
            matchDay
            gameAlias
            homeAway
            noPlay
            gameStats{
                observations
                homeShotsOnGoal
                awayShotsOnGoal
                homePenaltyMinutes
                awayPenaltyMinutes
                homeSaves
                awaySaves
                homePowerPlayGoals
                awayPowerPlayGoals
                homePowerPlayOpportunities
                awayPowerPlayOpportunities
                homeHits
                awayHits
                homeBlockedShots
                awayBlockedShots
            }
        }
        trainingSession{
            id
            participants{
                id
                fullName
            }
        }
        competition{
            id
            participants{
                id
                fullName
            }
        }
        attendances{
            profile{
                id
                fullName
            }
            confirmation
            attendance
        }
    }
  }
}
`;

export default function AddGameResultMutation() {
    return useMutation(ADD_GAME_RESULT_MUTATION);
}
